module.exports = __webpack_public_path__ + "img/angles-right.1d2b23e7.svg";